import { render, staticRenderFns } from "./add-physical-dialog.vue?vue&type=template&id=1d15b4b7"
import script from "./add-physical-dialog.vue?vue&type=script&lang=js"
export * from "./add-physical-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-physical-dialog.vue?vue&type=style&index=0&id=1d15b4b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports